import { render, staticRenderFns } from "./RegistrationSuccessPage.vue?vue&type=template&id=261f9b50&scoped=true"
import script from "./RegistrationSuccessPage.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./RegistrationSuccessPage.vue?vue&type=style&index=0&id=261f9b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f9b50",
  null
  
)

export default component.exports